import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../utils/firebaseConfig'; // 👈 Viktig: bruker riktig config
import AdminLayout from '../../components/AdminLayout'; // 👑 Layout med passordknapp
import AccessCodeList from '../../components/AccessCodeList'; // 🔑 Passordtabell

const ADMIN_UID = '3N1QaQpLuRfJXNPUypBXBE61V3F3';

const AdminScreen = () => {
  const [user, setUser] = useState(null);
  const [essensList, setEssensList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEssens = async () => {
    const snapshot = await getDocs(collection(db, 'kodeessens'));
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setEssensList(data);
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser?.uid === ADMIN_UID) {
        await fetchEssens();
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const slettEssens = async (uid) => {
    try {
      await deleteDoc(doc(db, 'kodeessens', uid));
      await fetchEssens();
      alert(`🗑️ Kode-Essens for ${uid} er slettet fra Firestore.`);
    } catch (error) {
      console.error('❌ Feil ved sletting:', error);
    }
  };

  if (loading) return <div style={styles.loading}>🔄 Laster...</div>;
  if (!user) return <div style={styles.notAllowed}>🔒 Du må være logget inn.</div>;
  if (user.uid !== ADMIN_UID) return <div style={styles.notAllowed}>🚫 Du har ikke tilgang.</div>;

  return (
    <AdminLayout>
      <h2 className="text-xl font-semibold text-white mb-4">👑 Adminpanel – Kode-Essens™</h2>

      {essensList.map((essens) => (
        <div key={essens.id} style={styles.card}>
          <p><strong>UID:</strong> {essens.id}</p>
          <p><strong>Kjennetegn:</strong> {essens.kjennetegn}</p>
          <p><strong>Kodeord:</strong> {essens.kodeord}</p>
          <p><strong>Essens-setning:</strong> {essens.essensSetning}</p>
          <p><strong>Tilkallingsformel:</strong> {essens.tilkallingsformel}</p>
          <button onClick={() => slettEssens(essens.id)} style={styles.deleteButton}>Slett</button>
        </div>
      ))}

      {/* 🔑 Viser passordtabellen under */}
      <AccessCodeList />
    </AdminLayout>
  );
};

const styles = {
  notAllowed: { color: 'orange', textAlign: 'center', marginTop: '4rem', fontSize: '1.2rem' },
  loading: { textAlign: 'center', color: '#aaa', marginTop: '3rem' },
  card: {
    backgroundColor: '#1a1a1a',
    border: '1px solid #444',
    borderRadius: '10px',
    padding: '1rem',
    margin: '1rem 0',
    color: 'white',
  },
  deleteButton: {
    marginTop: '1rem',
    backgroundColor: 'red',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '5px',
    cursor: 'pointer'
  }
};

export default AdminScreen;
